import React, { useEffect, useRef, useState } from "react";
import {
    Button, Table, Overlay,
    Popover, Col, Form, Row
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import { Chart } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    TimeScale,
    BarElement,
    LineElement,
    PointElement,
    Tooltip,
    Legend
} from 'chart.js';

import {
    CandlestickController,
    CandlestickElement
} from 'chartjs-chart-financial';
import DatePicker from "react-datepicker";


ChartJS.register(
    CategoryScale,
    LinearScale,
    TimeScale,
    BarElement,
    LineElement,
    PointElement,
    Tooltip,
    Legend,
    CandlestickController,
    CandlestickElement
);


export const ADRRoomSoldOHLC = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const propertyDetailFromRTK = useSelector((store) => store.headerProperty.propertyDetail);

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    let _candle_chart_options = {
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false
        },
        scales: {
            x: {
                title: {
                    display: false,
                    text: 'Stay Date'
                },
                ticks: {
                    autoSkip: false, // show all labels
                },
            },
            yRates: {
                position: 'left',
                title: {
                    display: true,
                    text: 'Rate'
                },
                min: 0,
                max: 100,
                ticks: {
                    stepSize: 10
                }
            },
            yRooms: {
                position: 'right',
                title: {
                    display: true,
                    text: 'Rooms Sold'
                },
                grid: {
                    drawOnChartArea: false
                }
            }
        },
        plugins: {
            legend: {
                position: 'top',
                align: 'end',
                labels: {
                    filter: function (legendItem, chartData) {
                        return (legendItem.text === 'ADR' || legendItem.text === 'STLY ADR');
                    }
                }
            },
            tooltip: {
                mode: 'index',
                intersect: false,
                callbacks: {
                    label: function (context) {
                        const dataset = context.dataset;
                        const dataPoint = context.raw;

                        // For candlestick chart
                        if (dataset.type === 'candlestick' && dataPoint && typeof dataPoint === 'object') {
                            return [
                                "OHLC",
                                `Opening: ${propertyDetailFromRTK?.currency_term + dataPoint.o}`,
                                `High: ${propertyDetailFromRTK?.currency_term + dataPoint.h}`,
                                `Low: ${propertyDetailFromRTK?.currency_term + dataPoint.l}`,
                                `Closing: ${propertyDetailFromRTK?.currency_term + dataPoint.c}`,
                            ];
                        }
                        return `${dataset.label}: ${(dataset.label !== "Room Sold" ? propertyDetailFromRTK?.currency_term : "") + context.formattedValue}`;
                    }
                }
            },
        }
    };

    let LastAsOfDate = defaultAsOfDateFromRTK ? new Date(defaultAsOfDateFromRTK) : new Date();

    const startOfMonth = new Date(LastAsOfDate.getFullYear(), LastAsOfDate.getMonth(), 1);
    const endOfMonth = new Date(LastAsOfDate.getFullYear(), LastAsOfDate.getMonth() + 1, 0);

    const [startDateForDashboard, setStartDateForDashboard] = useState(
        startOfMonth
    );
    const [endDateForDashboard, setEndDateForDashboard] = useState(
        endOfMonth
    );

    const handleDateChange = (event) => {
        const [start, end] = event;
        setStartDateForDashboard(start);
        setEndDateForDashboard(end);
    };

    let _candle_chart_data = {
        datasets: [
            {
                label: 'OHLC',
                type: 'candlestick',
                color: {
                    up: '#008000',
                    down: ' #FF5733',
                    unchanged: '#999'
                },
                data: [{ x: "", o: 0, h: 0, l: 0, c: 0, y: 0 }, { x: "", o: 0, h: 0, l: 0, c: 0, y: 0 }, { x: "", o: 0, h: 0, l: 0, c: 0, y: 0 }, { x: "", o: 0, h: 0, l: 0, c: 0, y: 0 }],
                yAxisID: 'yRates',
                borderColor: '#000',
                borderWidth: 1,
                order: 2,
                tension: 0.4,
                barPercentage: 0.4,
            },
            {
                label: 'ADR',
                type: 'line',
                data: [{ x: "", y: 0 }, { x: "", y: 0 }, { x: "", y: 0 }, { x: "", y: 0 }],
                yAxisID: 'yRates',
                borderColor: '#16279f',
                backgroundColor: '#16279f',
                tension: 0.4,
                fill: false,
                pointRadius: 4,
                order: 0,
            },
            {
                label: 'Room Sold',
                type: 'bar',
                data: [{ x: "", y: 0 }, { x: "", y: 0 }, { x: "", y: 0 }, { x: "", y: 0 }],
                yAxisID: 'yRooms',
                backgroundColor: '#a0d1ff85',
                borderColor: '#a0d1ff',
                borderWidth: 1,
                order: 3,
            },
            {
                label: 'STLY ADR',
                type: 'line',
                data: [{ x: "", y: 0 }, { x: "", y: 0 }, { x: "", y: 0 }, { x: "", y: 0 }],
                yAxisID: 'yRates',
                borderColor: '#118dff',
                backgroundColor: '#118dff',
                tension: 0.4,
                fill: false,
                pointRadius: 4,
                order: 1,
            },
        ]
    };

    const [candle_chart_data, setcandle_chart_data] = useState({ option: null, data: null });
    const [candle_chart_loader, setcandle_chart_loader] = useState(false);
    const candle_chart = async () => {
        setcandle_chart_loader(true)
        let customday = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.MONEY_CONTROL.CANDLE_CHART,
                body: {
                    "propertyCode": para?.propertyCode,
                    "startDate": commonService.getDateInDBFormat(startDateForDashboard),
                    "endDate": commonService.getDateInDBFormat(endDateForDashboard)
                },
            },
            false
        );

        let customdayresponse = apiResponse(false, customday);

        if (customdayresponse?.isValidate) {
            const sortedData = customdayresponse?.data?.data.sort((a, b) => new Date(a.StayDate) - new Date(b.StayDate));
            let RoomSold = [];
            let ADR = [];
            let STLYADR = [];
            let CandleData = [];
            let YMax = 100;
            for (let i = 0; i < sortedData.length; i++) {
                RoomSold.push({ x: commonService.getDateInDateMonthFormat(sortedData[i].StayDate), y: parseInt(sortedData[i].RoomSold) })
                ADR.push({ x: commonService.getDateInDateMonthFormat(sortedData[i].StayDate), y: parseInt(sortedData[i].ADR) })
                STLYADR.push({ x: commonService.getDateInDateMonthFormat(sortedData[i].StayDate), y: parseInt(sortedData[i].STLY_ADR) })
                CandleData.push({
                    x: commonService.getDateInDateMonthFormat(sortedData[i].StayDate),
                    o: parseFloat(sortedData[i].OpeningRate),
                    h: parseFloat(sortedData[i].HighRate),
                    l: parseFloat(sortedData[i].LowRate),
                    c: parseFloat(sortedData[i].ClosingRate),
                });

                if (YMax < parseInt(sortedData[i].ADR)) {
                    YMax = parseInt(sortedData[i].ADR);
                }

                if (YMax < parseInt(sortedData[i].STLY_ADR)) {
                    YMax = parseInt(sortedData[i].STLY_ADR);
                }

                if (YMax < parseInt(sortedData[i].HighRate)) {
                    YMax = parseInt(sortedData[i].HighRate);
                }

                if (YMax < parseInt(sortedData[i].OpeningRate)) {
                    YMax = parseInt(sortedData[i].OpeningRate);
                }

                if (YMax < parseInt(sortedData[i].LowRate)) {
                    YMax = parseInt(sortedData[i].LowRate);
                }

                if (YMax < parseInt(sortedData[i].ClosingRate)) {
                    YMax = parseInt(sortedData[i].ClosingRate);
                }
            }

            YMax = (YMax + 10);
            let avg = parseInt(YMax / 10);
            let dif1 = YMax - (avg * 10);
            YMax = YMax + (10 - dif1);

            _candle_chart_options.scales.yRates.max = YMax;

            _candle_chart_data.datasets[0].data = CandleData;
            _candle_chart_data.datasets[1].data = ADR;
            _candle_chart_data.datasets[2].data = RoomSold;
            _candle_chart_data.datasets[3].data = STLYADR;

            setcandle_chart_data({
                option: _candle_chart_options,
                data: _candle_chart_data
            })
        }
        else {
            setcandle_chart_data({
                option: _candle_chart_options,
                data: _candle_chart_data
            })
        }

        setcandle_chart_loader(false)

    }

    useEffect(() => {
        if (api === 0) {
            setcandle_chart_data({
                option: _candle_chart_options,
                data: _candle_chart_data
            })
        } else {
            if (para?.propertyCode && startDateForDashboard && endDateForDashboard) {
                candle_chart();
            }
        }
    }, [para?.propertyCode, startDateForDashboard, endDateForDashboard]);

    return (
        <div className="widget-container" style={{position: "relative", padding: "0 5px"}}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">

                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("ADRRoomSoldOHLC", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.ADRRoomSoldOHLC,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>

                </div>
            )}
            <Row>
                <Col xl={3}>
                    <DatePicker id={commonService.generateGlobalClickTrackerID("ADRRoomSoldOHLC", "datepicker-onchange", propertyCode)}
                        portalId="datepicker-root"
                        onChange={(event) => handleDateChange(event)}
                        startDate={startDateForDashboard ? startDateForDashboard : ""}
                        endDate={endDateForDashboard ? endDateForDashboard : ""}
                        selectsRange
                        monthsShown={2}
                    />
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    {
                        candle_chart_loader ?
                            <Loader /> :
                            <>
                                {
                                    candle_chart_data && candle_chart_data.data &&
                                    <Chart type="bar" data={candle_chart_data.data} options={candle_chart_data.option} />
                                }
                            </>
                    }

                </Col>
            </Row>
            {api !== 0 && <Comments widgetDetails={para} editorId={"ADRRoomSoldOHLC"} />}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};


export default ADRRoomSoldOHLC;
